import { type StateCreator } from 'zustand';

import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

export const SearchMode = {
  CLASSIC: 'classic',
  AI: 'AI',
} as const;

export type SearchMode = (typeof SearchMode)[keyof typeof SearchMode];

export type SearchModeState = {
  searchMode: SearchMode;
  modalSearchMode: SearchMode;
};

type SearchModeActions = {
  setSearchMode: (searchMode: SearchMode) => void;
  toggleSearchMode: () => void;
  setModalSearchMode: (modalSearchMode: SearchMode) => void;
};

export type SearchModeStore = SearchModeState & SearchModeActions;

export const defaultSearchModeState: Readonly<SearchModeState> = {
  searchMode: SearchMode.CLASSIC,
  modalSearchMode: SearchMode.CLASSIC,
};

export const createSearchModeSlice: StateCreator<SearchStore, MiddlewareType, [], SearchModeStore> = (set) => {
  return {
    ...defaultSearchModeState,
    setSearchMode: (searchMode: SearchMode) => set({ searchMode }, undefined, 'setSearchMode'),
    toggleSearchMode: () => set((state) => ({ searchMode: state.searchMode === SearchMode.CLASSIC ? SearchMode.AI : SearchMode.CLASSIC })),
    setModalSearchMode: (modalSearchMode: SearchMode) => set({ modalSearchMode }, undefined, 'setModalSearchMode'),
  };
};
